import clsx from 'clsx';
import { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import classes from './Popover.module.css';
const PopoverBox = ({ children, list, onClick, direction = 'left', className }) => {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <div className="popover-container">
      <Popover
        className={clsx(className, classes.popoverBox)}
        onClick={(e) => {
          if (typeof onClick == 'function') onClick();
        }}
        isOpen={isPopoverOpen}
        // parentElement={boxContainerRef.current}
        positions={[direction, 'right', 'top', 'bottom']}
        align="start"
        padding={8}
        top={19}
        style={{ marginRight: '20%' }}
        onClickOutside={() => setIsPopoverOpen(false)}
        // content={<div className="popover-content">{popup}</div>}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            className={classes.containerBg}
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={'#fff'}
            arrowSize={10}
            arrowStyle={{ boxShadow: '0px 0px 4px 0px #00000026' }}>
            <div>
              <menu className={clsx('popover-content', classes.menu)}>{list}</menu>
            </div>
          </ArrowContainer>
        )}>
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsPopoverOpen((current) => !current);
          }}
          className="btn-container">
          {children}
        </div>
      </Popover>
    </div>
  );
};

export default PopoverBox;
